//  --PLATFORM ENVS
//  local
//  production
export const APP_ENV = 'production';
/** When false, pages use legacy `.loading` spinners instead of layout skeletons. */
export const USE_SKELETON_LOADERS = true;
//  --PLATFORM ENVS
//  landing
//  application
export const PLATFORM_ENV = 'application';
export const CAPTCHA_COST = 0.15;
// Set via REACT_APP_PREFETCH_COST in .env (Create React App); default 0.01 credits per prefetch option per account
export const PREFETCH_COST = (() => {
  const raw = process.env.REACT_APP_PREFETCH_COST;
  const n = raw != null && raw !== '' ? parseFloat(raw, 10) : NaN;
  return Number.isFinite(n) ? n : 0.01;
})();
// Set via REACT_APP_AUTO_REFRESH_COST; default 0.01 credits per auto-refresh option per account per day
export const AUTO_REFRESH_COST = (() => {
  const raw = process.env.REACT_APP_AUTO_REFRESH_COST;
  const n = raw != null && raw !== '' ? parseFloat(raw, 10) : NaN;
  return Number.isFinite(n) ? n : 0.01;
})();
// Credits charged per successful reminder hit (backend); default 1
export const REMINDER_HIT_COST = (() => {
  const raw = process.env.REACT_APP_REMINDER_HIT_COST;
  const n = raw != null && raw !== '' ? parseFloat(raw, 10) : NaN;
  return Number.isFinite(n) ? n : 1;
})();
export const DASHBOARD_URL = 'https://app.explorant.space';
export const PAID_DASHBOARD_URLS = [
  // 'http://888818881.xyz',
  // 'http://999919991.xyz',
  // 'http://999929991.xyz',
  'http://515e1317-2df9-4ceb-b8c4-b60b2633359f.buzz',
  'http://808be016-4b51-47a0-9df3-552f1b3448af.buzz'
  // 'http://8c3de257-d7ef-4309-8dcb-1ca52825dfcc.buzz',
  // 'http://9bac6031-c824-43dd-8b69-566fe37fa719.buzz',
  // 'http://fe1964a2-5c8d-444a-8174-7c4f9a221410.buzz',
];
